import * as Phaser from "phaser-ce"
import { PhaserUtils } from "../../utils/PhaserUtils"

export enum PongAssets {
    BACKGROUND = "PongBACKGROUND",
    PADDLE = "PongPADDLE",
    SCORE_SCREEN = "PongSCORE_SCREEN",

    ADDICTOMETER = "PongADDICTOMETER",
    EXPLODE = "PongEXPLODE",
    PONG_CIGARETTE = "PongPONG_CIGARETTE",
    PONG_VAPE = "PongPONG_VAPE",
    SMOKING_CIG = "PongSMOKING_CIG",
    VAPING_VAPE = "PongVAPING_VAPE",

    // Audio enum values below here
    TOTALLY_GAME_OVER = "PongTOTALLY_GAME_OVER",
    SOMEWHAT_GAME_OVER = "PongSOMEWHAT_GAME_OVER",
    CRUMPLE = "PongCRUMPLE",
    INHALE = "PongINHALE",

    INTRO = "PongINTRO",
    BACK_TO_ARCADE = "PongBACK_TO_ARCADE",
    NOT_ADDICTED_1 = "PongNOT_ADDICTED_1",
    NOT_ADDICTED_2 = "PongNOT_ADDICTED_2",
    NOT_ADDICTED_3 = "PongNOT_ADDICTED_3",
    SOMEWHAT_ADDICTED_1 = "PongSOMEWHAT_ADDICTED_1",
    SOMEWHAT_ADDICTED_2 = "PongSOMEWHAT_ADDICTED_2",
    SOMEWHAT_ADDICTED_3 = "PongSOMEWHAT_ADDICTED_3",
    TOTALLY_ADDICTED_1 = "PongTOTALLY_ADDICTED_1",
    TOTALLY_ADDICTED_2 = "PongTOTALLY_ADDICTED_2",
    TOTALLY_ADDICTED_3 = "PongTOTALLY_ADDICTED_3",

    // Testimonial Outro Assets
    OUTRO1 = "PongOUTRO1",

    BUDDY_TESTIMONIALS_INTRO = "PongBUDDY_TESTIMONIALS_INTRO",

    TESTIMONIAL_1 = "PongTESTIMONIAL_1",
    TESTIMONIAL_2 = "PongTESTIMONIAL_2",
    TESTIMONIAL_3 = "PongTESTIMONIAL_3",
    TESTIMONIAL_4 = "PongTESTIMONIAL_4",

    TESTIMONIAL_1_IMAGE = "PongTESTIMONIAL_1_IMAGE",
    TESTIMONIAL_2_IMAGE = "PongTESTIMONIAL_2_IMAGE",
    TESTIMONIAL_3_IMAGE = "PongTESTIMONIAL_3_IMAGE",
    TESTIMONIAL_4_IMAGE = "PongTESTIMONIAL_4_IMAGE",
}

export function loadAssets(game: Phaser.Game) {
    
    const load = PhaserUtils.makeLoader(game, "pong")
    
    load.image(PongAssets.BACKGROUND, "background.png")
    load.image(PongAssets.PADDLE, "bar.png")
    load.image(PongAssets.SCORE_SCREEN, "scores-bg.png")

    load.spritesheet(PongAssets.ADDICTOMETER, "addictometer.png", 100, 461)
    load.spritesheet(PongAssets.EXPLODE, "explode.png", 275, 297)
    load.spritesheet(PongAssets.PONG_CIGARETTE, "crumple-cig.png", 109, 20)
    load.spritesheet(PongAssets.SMOKING_CIG, "smoking-cig.png", 119, 260)
    load.spritesheet(PongAssets.PONG_VAPE, "vape-crumpling.png", 109, 12)
    load.spritesheet(PongAssets.VAPING_VAPE, "vape-vaping.png", 91, 62)

    load.audio(PongAssets.TOTALLY_GAME_OVER, "beeping-breaking.wav")
    load.audio(PongAssets.SOMEWHAT_GAME_OVER, "somewhat-addicted.wav")
    load.audio(PongAssets.CRUMPLE, "crumple.wav")
    load.audio(PongAssets.INHALE, "inhale.wav")

    load.audio(PongAssets.INTRO, "intro.mp3")
    load.audio(PongAssets.BACK_TO_ARCADE, "back-to-arcade.mp3")
    load.audio(PongAssets.NOT_ADDICTED_1, "not-addicted.mp3")
    load.audio(PongAssets.NOT_ADDICTED_2, "not-addicted2.mp3")
    load.audio(PongAssets.NOT_ADDICTED_3, "not-addicted3.mp3")
    load.audio(PongAssets.SOMEWHAT_ADDICTED_1, "somewhat-addicted.mp3")
    load.audio(PongAssets.SOMEWHAT_ADDICTED_2, "somewhat-addicted2.mp3")
    load.audio(PongAssets.SOMEWHAT_ADDICTED_3, "somewhat-addicted3.mp3")
    load.audio(PongAssets.TOTALLY_ADDICTED_1, "totally-addicted.mp3")
    load.audio(PongAssets.TOTALLY_ADDICTED_2, "totally-addicted2.mp3")
    load.audio(PongAssets.TOTALLY_ADDICTED_3, "totally-addicted3.mp3")

}
